/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AddressView } from '../model/addressView';
// @ts-ignore
import { CreateRdSapReport } from '../model/createRdSapReport';
// @ts-ignore
import { GeneralResponse } from '../model/generalResponse';
// @ts-ignore
import { RdSAPAssessmentReportCreateData } from '../model/rdSAPAssessmentReportCreateData';
// @ts-ignore
import { RdSAPAssessmentReportMimeTypes } from '../model/rdSAPAssessmentReportMimeTypes';
// @ts-ignore
import { RdSAPAssessmentReportSearchResult } from '../model/rdSAPAssessmentReportSearchResult';
// @ts-ignore
import { RdSAPAssessmentReportSummary } from '../model/rdSAPAssessmentReportSummary';
// @ts-ignore
import { RdSAPAssessmentReportUIDTOV0 } from '../model/rdSAPAssessmentReportUIDTOV0';
// @ts-ignore
import { ReportAction } from '../model/reportAction';
// @ts-ignore
import { ReportStatus } from '../model/reportStatus';
// @ts-ignore
import { ReportType } from '../model/reportType';
// @ts-ignore
import { SapCountryCodesV0 } from '../model/sapCountryCodesV0';
// @ts-ignore
import { SapVersion } from '../model/sapVersion';
// @ts-ignore
import { SchemaVersion } from '../model/schemaVersion';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AssessmentReportsDeprecatedService {

    protected basePath = 'https://rdsap-api.quidossoftware.co.uk';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Creates a new &#x60;RdSAP Assessment Report&#x60;
     * Creates a new report with a default set of data which belongs to the &#x60;QUID&#x60; of the authenticated user.  The new report is created for: - the &#x60;authenticated&#x60; user; - the specified Address; - with the &#x60;AssessmentDate&#x60; given; - with the &#x60;reportStatus&#x60; set to &#x60;IN-PROGRESS&#x60;;  A description and link to the new resource, is effectively created before the response is sent back and the newly created item is located at the URL in the value of the Location header.
     * @param rdSAPAssessmentReportCreateData 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public createAssessment(rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GeneralResponse>;
    public createAssessment(rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GeneralResponse>>;
    public createAssessment(rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GeneralResponse>>;
    public createAssessment(rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rdSAPAssessmentReportCreateData === null || rdSAPAssessmentReportCreateData === undefined) {
            throw new Error('Required parameter rdSAPAssessmentReportCreateData was null or undefined when calling createAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report`;
        return this.httpClient.request<GeneralResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rdSAPAssessmentReportCreateData,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a new EPC RdSAP assessment report
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/epc\&#39; instead. Creates a new EPC with a default set of data (for JSON) or with data provided in XML (for XML) which belongs to the &#x60;QUID&#x60; of the authenticated user. The new report is created for: - the &#x60;authenticated&#x60; user; - the specified Address; - with the &#x60;AssessmentDate&#x60; given; - with the &#x60;reportStatus&#x60; set to &#x60;IN-PROGRESS&#x60;; A description and link to the new resource, is effectively created before the response is sent back and the newly created item is located at the URL in the value of the Location header.
     * @param body 
     * @param contentType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public createEpc(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GeneralResponse>;
    public createEpc(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GeneralResponse>>;
    public createEpc(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GeneralResponse>>;
    public createEpc(body: string, contentType?: 'application/json' | 'application/xml', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createEpc.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (contentType !== undefined && contentType !== null) {
            localVarHeaders = localVarHeaders.set('Content-Type', String(contentType));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/epc`;
        return this.httpClient.request<GeneralResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a new EPR RdSAP assessment report
     * Creates a new EPR with a default set of data (for JSON) or with data provided in XML (for XML) which belongs to the &#x60;QUID&#x60; of the authenticated user. The new report is created for: - the &#x60;authenticated&#x60; user; - the specified Address; - with the &#x60;AssessmentDate&#x60; given; - with the &#x60;reportStatus&#x60; set to &#x60;IN-PROGRESS&#x60;; A description and link to the new resource, is effectively created before the response is sent back and the newly created item is located at the URL in the value of the Location header.
     * @param body 
     * @param contentType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public createEpr(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GeneralResponse>;
    public createEpr(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GeneralResponse>>;
    public createEpr(body: string, contentType?: 'application/json' | 'application/xml', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GeneralResponse>>;
    public createEpr(body: string, contentType?: 'application/json' | 'application/xml', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createEpr.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (contentType !== undefined && contentType !== null) {
            localVarHeaders = localVarHeaders.set('Content-Type', String(contentType));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/xml',
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/epr`;
        return this.httpClient.request<GeneralResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a duplicate&#x60;RdSAP Assessment Report&#x60;
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}\&#39; instead. Creates a new/duplicate report with a default set of data.  The new report is created for: - the current user; - the specified Address; - with the AssessmentDate given; - with the data of the original report.  A description and link to the new resource, is effectively created before the response is sent back and the newly created item is located at the URL in the value of the Location header.
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param rdSAPAssessmentReportCreateData The new assessment date of the copy.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public duplicateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GeneralResponse>;
    public duplicateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GeneralResponse>>;
    public duplicateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GeneralResponse>>;
    public duplicateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportCreateData: RdSAPAssessmentReportCreateData, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling duplicateAssessment.');
        }
        if (rdSAPAssessmentReportCreateData === null || rdSAPAssessmentReportCreateData === undefined) {
            throw new Error('Required parameter rdSAPAssessmentReportCreateData was null or undefined when calling duplicateAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<GeneralResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rdSAPAssessmentReportCreateData,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the &#x60;address&#x60; of the&#x60;RdSAP Assessment Report&#x60;.
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}/address\&#39; instead.  Retrieves &#x60;the address&#x60; for an &#x60;RdSAP Assessment Report&#x60; for a specific property address. 
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getAssessmentAddress(reportReferenceNumber: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<AddressView>;
    public getAssessmentAddress(reportReferenceNumber: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AddressView>>;
    public getAssessmentAddress(reportReferenceNumber: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AddressView>>;
    public getAssessmentAddress(reportReferenceNumber: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling getAssessmentAddress.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/address`;
        return this.httpClient.request<AddressView>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search for&#x60;RdSAP Assessment Reports&#x60;
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report\&#39; instead. Lists all the RdSAP assessment reports that the match the search criteria and the &#x60;QUID&#x60; of the &#x60;authenticated&#x60; user can access that match the query params. The returned data objects are always ordered by Assessment Date descending (oldest last). Any other ordering needs to be performed by the API client.
     * @param reportType The type of report that needs to be search for.
     * @param countryCode &#x60;AND FILTER&#x60; - The country to search for.
     * @param reportStatus &#x60;AND FILTER&#x60; - Filter by the report status to search for.
     * @param dateFrom &#x60;AND FILTER&#x60; - Filter by the minimum date when finalised.  Works with the &#x60;reportStatus&#x60; field and the appropriate date field for that status.  When &#x60;reportStatus&#x3D;IN-PROGRESS&#x60; search using &#x60;lastEditedDate&#x60;;  When &#x60;reportStatus&#x3D;CALCULATED&#x60; search using &#x60;calculatedDate&#x60;;  When &#x60;reportStatus&#x3D;COMPLETED&#x60; search using &#x60;completedDate&#x60;;  When &#x60;reportStatus&#x3D;LODGED&#x60; search using &#x60;lodgementDate&#x60;;  When &#x60;reportStatus&#x3D;FINALISED&#x60; search using &#x60;finalisedDate&#x60;;  When &#x60;reportStatus&#x3D;CANCELLED&#x60; search using &#x60;canceledDate&#x60;;
     * @param dateTo &#x60;AND FILTER&#x60; - Filter by the minimum date for lodgement.  Works with the &#x60;reportStatus&#x60; field and the appropriate date field for that status.  **See &#x60;dateFrom&#x60; for a full description.**
     * @param addressLine1 &#x60;OR FILTER&#x60; - Part or exact match of the address.  &#x60;WILD CARD&#x60; - Supports wildcard prefix &amp; postfix Add \&quot;*\&quot; to the search ie. \&quot;*XXX*\&quot; 
     * @param uprn &#x60;OR FILTER&#x60; - UPRN as search parameters to filter by.
     * @param reportReferenceNumber &#x60;AND FILTER&#x60; - The report reference as a search value.  Especially useful for retrieving the full URL to retrieve the report.  AKA the &#x60;rrn&#x60;.
     * @param postcode &#x60;OR FILTER&#x60; - Part or exact match of the postcode.  &#x60;WILD CARD&#x60; - Supports wildcard prefix &amp; postfix Add \&quot;*\&quot; to the search ie. \&quot;*XXX*\&quot; 
     * @param includeEnergyData Defaults to false. When &#x60;true&#x60; the list includes &#x60;$.energyData&#x60; objects within the &#x60;Summary&#x60;.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public listAssessment(reportType: ReportType, countryCode?: SapCountryCodesV0, reportStatus?: ReportStatus, dateFrom?: string, dateTo?: string, addressLine1?: string, uprn?: string, reportReferenceNumber?: string, postcode?: string, includeEnergyData?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RdSAPAssessmentReportSearchResult>>;
    public listAssessment(reportType: ReportType, countryCode?: SapCountryCodesV0, reportStatus?: ReportStatus, dateFrom?: string, dateTo?: string, addressLine1?: string, uprn?: string, reportReferenceNumber?: string, postcode?: string, includeEnergyData?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RdSAPAssessmentReportSearchResult>>>;
    public listAssessment(reportType: ReportType, countryCode?: SapCountryCodesV0, reportStatus?: ReportStatus, dateFrom?: string, dateTo?: string, addressLine1?: string, uprn?: string, reportReferenceNumber?: string, postcode?: string, includeEnergyData?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RdSAPAssessmentReportSearchResult>>>;
    public listAssessment(reportType: ReportType, countryCode?: SapCountryCodesV0, reportStatus?: ReportStatus, dateFrom?: string, dateTo?: string, addressLine1?: string, uprn?: string, reportReferenceNumber?: string, postcode?: string, includeEnergyData?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportType === null || reportType === undefined) {
            throw new Error('Required parameter reportType was null or undefined when calling listAssessment.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (countryCode !== undefined && countryCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>countryCode, 'countryCode');
        }
        if (reportStatus !== undefined && reportStatus !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reportStatus, 'reportStatus');
        }
        if (dateFrom !== undefined && dateFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dateFrom, 'dateFrom');
        }
        if (dateTo !== undefined && dateTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dateTo, 'dateTo');
        }
        if (addressLine1 !== undefined && addressLine1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>addressLine1, 'addressLine1');
        }
        if (uprn !== undefined && uprn !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>uprn, 'uprn');
        }
        if (reportReferenceNumber !== undefined && reportReferenceNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reportReferenceNumber, 'reportReferenceNumber');
        }
        if (postcode !== undefined && postcode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>postcode, 'postcode');
        }
        if (reportType !== undefined && reportType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reportType, 'reportType');
        }
        if (includeEnergyData !== undefined && includeEnergyData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>includeEnergyData, 'includeEnergyData');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report`;
        return this.httpClient.request<Array<RdSAPAssessmentReportSearchResult>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get an EXISTING &#x60;RdSAP Assessment Report&#x60;
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}\&#39; instead.  Retrieves a specific RdSAP Assessment report. The request will fail if the data belongs to a &#x60;QUID&#x60; that is not the authenticated user. The format of the report data depends on what was requested. - For RsDAP 994 - &#x60;application/xml+RdSAP-Schema-20.0.0&#x60;  - For either of the XML types regardless of schema - &#x60;application/xml&#x60;, the returned mime-type will define what is returned. - For the RdSAP UI - &#x60;application/json+RdSAP-quidos-ui&#x60;  - General summary - &#x60;application/json+RdSAP-Summary&#x60; 
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param accept In the API service, include &#x60;Accept&#x60; in the  HTTP request header. This is a CSV header with all the header types acceptable to the client. The definition of an Accept header can be found at https://www.rfc-editor.org/rfc/rfc7231#section-5.3.2.  The format of this header should be one of the defined mime-types.   To deal with **error conditions** the client should also add &#x60;application/json&#x60; to the header. For example: &#x60;application/json,application/json+RdSAP-quidos-ui&#x60;.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public readAssessment(reportReferenceNumber: string, accept: RdSAPAssessmentReportMimeTypes, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json+RdSAP-Summary' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public readAssessment(reportReferenceNumber: string, accept: RdSAPAssessmentReportMimeTypes, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json+RdSAP-Summary' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public readAssessment(reportReferenceNumber: string, accept: RdSAPAssessmentReportMimeTypes, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json+RdSAP-Summary' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public readAssessment(reportReferenceNumber: string, accept: RdSAPAssessmentReportMimeTypes, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json+RdSAP-Summary' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling readAssessment.');
        }
        if (accept === null || accept === undefined) {
            throw new Error('Required parameter accept was null or undefined when calling readAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accept !== undefined && accept !== null) {
            localVarHeaders = localVarHeaders.set('Accept', String(accept));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/xml+RdSAP-Schema-20.0.0',
                'application/json+RdSAP-quidos-ui',
                'application/json+RdSAP-Summary',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<string>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an EXISTING &#x60;RdSAP Assessment Report&#x60;
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}\&#39; instead. Update the RdSAP Assessment Report for the property address Overwrites the current active RdSAP Assessment Report with this data. When the date is updated the calculation becomes invalid so the state of the report will alter.  There are several conditions related to this process that are:     - An Update can only occur when with the &#x60;reportStatus&#x60; is set to &#x60;IN-PROGRESS&#x60; | &#x60;CALCULATED&#x60; | &#x60;COMPLETED&#x60; ; - When updated the &#x60;reportStatus&#x60; is set to &#x60;IN-PROGRESS&#x60;. 
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param rdSAPAssessmentReportUIDTOV0 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public updateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportUIDTOV0: RdSAPAssessmentReportUIDTOV0, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GeneralResponse>;
    public updateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportUIDTOV0: RdSAPAssessmentReportUIDTOV0, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GeneralResponse>>;
    public updateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportUIDTOV0: RdSAPAssessmentReportUIDTOV0, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GeneralResponse>>;
    public updateAssessment(reportReferenceNumber: string, rdSAPAssessmentReportUIDTOV0: RdSAPAssessmentReportUIDTOV0, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling updateAssessment.');
        }
        if (rdSAPAssessmentReportUIDTOV0 === null || rdSAPAssessmentReportUIDTOV0 === undefined) {
            throw new Error('Required parameter rdSAPAssessmentReportUIDTOV0 was null or undefined when calling updateAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<GeneralResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rdSAPAssessmentReportUIDTOV0,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the status of the &#x60;RdSAP Assessment Report&#x60;
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/{reportReferenceNumber}\&#39; instead.  Performs an update of the status of the report, based on the &#x60;action&#x60; parameter. Business logic TBC.
     * @param reportReferenceNumber &#x60;RdSAP Assessment Report&#x60; Number.  The Unique Id &amp; primary index for storage.  This value is globally unique.
     * @param action 
     * @param accept Defines the format of the report the client will get in the response  (application/json+RdSAP-quidos-ui is returned by default). 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public updateAssessmentStatus(reportReferenceNumber: string, action: ReportAction, accept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json+RdSAP-quidos-ui' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RdSAPAssessmentReportUIDTOV0>;
    public updateAssessmentStatus(reportReferenceNumber: string, action: ReportAction, accept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json+RdSAP-quidos-ui' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RdSAPAssessmentReportUIDTOV0>>;
    public updateAssessmentStatus(reportReferenceNumber: string, action: ReportAction, accept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json+RdSAP-quidos-ui' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RdSAPAssessmentReportUIDTOV0>>;
    public updateAssessmentStatus(reportReferenceNumber: string, action: ReportAction, accept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json+RdSAP-quidos-ui' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (reportReferenceNumber === null || reportReferenceNumber === undefined) {
            throw new Error('Required parameter reportReferenceNumber was null or undefined when calling updateAssessmentStatus.');
        }
        if (action === null || action === undefined) {
            throw new Error('Required parameter action was null or undefined when calling updateAssessmentStatus.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (action !== undefined && action !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>action, 'action');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accept !== undefined && accept !== null) {
            localVarHeaders = localVarHeaders.set('Accept', String(accept));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json+RdSAP-quidos-ui',
                'application/xml+RdSAP-Schema-20.0.0',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/${this.configuration.encodeParam({name: "reportReferenceNumber", value: reportReferenceNumber, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RdSAPAssessmentReportUIDTOV0>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Convert the &#x60;RdSAP Assessment Report&#x60; to a different format
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/convert\&#39; instead.  Converts given &#x60;RdSAP Assessment Report&#x60; to the specified format. Conversion can be done from JSON to XML and vice versa. 
     * @param accept Defines the format report must be converted to. Note that \&#39;application/json\&#39; mime type  must always be present, in case error response is retruned 
     * @param contentType Defines the format of the original report sent in the request body. Note that if report format is application/xml+RdSAP-Schema-20.0.0, charset parameter is required  (e.g application/xml+RdSAP-Schema-20.0.0;charset&#x3D;UTF-8). If report format is application/json+RdSAP-quidos-ui, charset may be omitted, default is UTF-8 in this case. 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public v1ReportConvertPost(accept: 'application/json' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', contentType: string, body?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public v1ReportConvertPost(accept: 'application/json' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', contentType: string, body?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public v1ReportConvertPost(accept: 'application/json' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', contentType: string, body?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public v1ReportConvertPost(accept: 'application/json' | 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui', contentType: string, body?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/xml+RdSAP-Schema-20.0.0' | 'application/json+RdSAP-quidos-ui' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accept === null || accept === undefined) {
            throw new Error('Required parameter accept was null or undefined when calling v1ReportConvertPost.');
        }
        if (contentType === null || contentType === undefined) {
            throw new Error('Required parameter contentType was null or undefined when calling v1ReportConvertPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accept !== undefined && accept !== null) {
            localVarHeaders = localVarHeaders.set('Accept', String(accept));
        }
        if (contentType !== undefined && contentType !== null) {
            localVarHeaders = localVarHeaders.set('Content-Type', String(contentType));
        }

        let localVarCredential: string | undefined;
        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/xml+RdSAP-Schema-20.0.0',
                'application/json+RdSAP-quidos-ui',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/xml+RdSAP-Schema-20.0.0',
            'application/json+RdSAP-quidos-ui'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/convert`;
        return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validate the &#x60;RdSAP Assessment Report&#x60; XML
     * Note that this endpoint is deprecated. Please, use \&#39;/rdsap994/v1/report/validate\&#39; instead.  Checks that report in the XML format is valid according to the schema. 
     * @param contentType Defines the format of the report sent in the request body. Note that charset parameter is required  (e.g application/xml+RdSAP-Schema-20.0.0;charset&#x3D;UTF-8). 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public v1ReportValidatePost(contentType: 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-8' | 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-16', body?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public v1ReportValidatePost(contentType: 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-8' | 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-16', body?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public v1ReportValidatePost(contentType: 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-8' | 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-16', body?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public v1ReportValidatePost(contentType: 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-8' | 'application/xml+RdSAP-Schema-20.0.0;charset=UTF-16', body?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (contentType === null || contentType === undefined) {
            throw new Error('Required parameter contentType was null or undefined when calling v1ReportValidatePost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (contentType !== undefined && contentType !== null) {
            localVarHeaders = localVarHeaders.set('Content-Type', String(contentType));
        }

        let localVarCredential: string | undefined;
        // authentication (X-API-KEY) required
        localVarCredential = this.configuration.lookupCredential('X-API-KEY');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('X-API-KEY', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/xml+RdSAP-Schema-20.0.0'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/report/validate`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
